export enum KCCustomQuestionKeys {
  BUSINESS_OWNER_NAME = 'businessOwnerName',
  COMPANY_LEGAL_NAME = 'companyLegalName',
  DOING_BUSINESS_AS = 'doingBusinessAs',
  CREDIT_SCORE = 'creditScore',
  TITLE = 'title',
  PRODUCTS_SERVICES = 'productsServices',
  EMPLOYEES = 'employees',
  BUSINESS_ADDRESS = 'businessAddress',
  BUSINESS_LICENSE = 'businessLicense',
  TAX_CLEARANCE_LETTER = 'taxClearanceLetter',
  YEARS_IN_BUSINESS = 'yearsInBusiness',
  YEAR_ESTABLISHED = 'yearEstablished',
  BUSINESS_BANK_ACCOUNT = 'businessBankAccount',
  DEPENDENTS = 'dependents',
  NET_WORTH_EXCEEDS = 'netWorthExceeds',
}
